import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "d-flex flex-column flex-xl-row" }
const _hoisted_2 = { class: "flex-column flex-lg-row-auto w-100 w-xl-350px mb-10" }
const _hoisted_3 = { class: "card mb-5 mb-xl-8" }
const _hoisted_4 = { class: "card-body pt-15" }
const _hoisted_5 = { class: "d-flex flex-center flex-column mb-5" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "symbol symbol-100px symbol-circle mb-7" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: "media/avatars/150-26.jpg",
    alt: "image"
  })
], -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("a", {
  href: "#",
  class: "fs-3 text-gray-800 text-hover-primary fw-bolder mb-1"
}, " Rakib Hasan ", -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "fs-5 fw-bold text-muted mb-6" }, "Software Enginer", -1)
const _hoisted_9 = { class: "d-flex flex-wrap flex-center" }
const _hoisted_10 = { class: "border border-gray-300 border-dashed rounded py-3 px-3 mb-3" }
const _hoisted_11 = { class: "fs-4 fw-bolder text-gray-700" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("span", { class: "w-75px" }, "6,900", -1)
const _hoisted_13 = { class: "svg-icon svg-icon-3 svg-icon-success" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("div", { class: "fw-bold text-muted" }, "Earnings", -1)
const _hoisted_15 = { class: "border border-gray-300 border-dashed rounded py-3 px-3 mx-4 mb-3" }
const _hoisted_16 = { class: "fs-4 fw-bolder text-gray-700" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("span", { class: "w-50px" }, "130", -1)
const _hoisted_18 = { class: "svg-icon svg-icon-3 svg-icon-danger" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("div", { class: "fw-bold text-muted" }, "Tasks", -1)
const _hoisted_20 = { class: "border border-gray-300 border-dashed rounded py-3 px-3 mb-3" }
const _hoisted_21 = { class: "fs-4 fw-bolder text-gray-700" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("span", { class: "w-50px" }, "500", -1)
const _hoisted_23 = { class: "svg-icon svg-icon-3 svg-icon-success" }
const _hoisted_24 = /*#__PURE__*/_createElementVNode("div", { class: "fw-bold text-muted" }, "Hours", -1)
const _hoisted_25 = { class: "d-flex flex-stack fs-4 py-3" }
const _hoisted_26 = {
  class: "fw-bolder rotate collapsible",
  "data-bs-toggle": "collapse",
  href: "#kt_customer_view_details",
  role: "button",
  "aria-expanded": "false",
  "aria-controls": "kt_customer_view_details"
}
const _hoisted_27 = { class: "ms-2 rotate-180" }
const _hoisted_28 = { class: "svg-icon svg-icon-3" }
const _hoisted_29 = /*#__PURE__*/_createElementVNode("span", {
  "data-bs-toggle": "tooltip",
  "data-bs-trigger": "hover",
  title: "Edit customer details"
}, [
  /*#__PURE__*/_createElementVNode("a", {
    href: "#",
    class: "btn btn-sm btn-light-primary",
    "data-bs-toggle": "modal",
    "data-bs-target": "#kt_modal_update_customer"
  }, " Edit ")
], -1)
const _hoisted_30 = /*#__PURE__*/_createStaticVNode("<div class=\"separator separator-dashed my-3\"></div><div id=\"kt_customer_view_details\" class=\"collapse show\"><div class=\"py-5 fs-6\"><div class=\"badge badge-light-info d-inline\">Premium user</div><div class=\"fw-bolder mt-5\">Account ID</div><div class=\"text-gray-600\">ID-45453423</div><div class=\"fw-bolder mt-5\">Billing Email</div><div class=\"text-gray-600\"><a href=\"#\" class=\"text-gray-600 text-hover-primary\">info@keenthemes.com</a></div><div class=\"fw-bolder mt-5\">Billing Address</div><div class=\"text-gray-600\"> 101 Collin Street, <br>Melbourne 3000 VIC <br>Australia </div><div class=\"fw-bolder mt-5\">Language</div><div class=\"text-gray-600\">English</div><div class=\"fw-bolder mt-5\">Upcoming Invoice</div><div class=\"text-gray-600\">54238-8693</div><div class=\"fw-bolder mt-5\">Tax ID</div><div class=\"text-gray-600\">TX-8674</div></div></div>", 2)
const _hoisted_32 = { class: "card mb-5 mb-xl-8" }
const _hoisted_33 = /*#__PURE__*/_createElementVNode("div", { class: "card-header border-0" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "card-title" }, [
    /*#__PURE__*/_createElementVNode("h3", { class: "fw-bolder m-0" }, "Connected Accounts")
  ])
], -1)
const _hoisted_34 = { class: "card-body pt-2" }
const _hoisted_35 = { class: "notice d-flex bg-light-primary rounded border-primary border border-dashed mb-9 p-6" }
const _hoisted_36 = { class: "svg-icon svg-icon-2tx svg-icon-primary me-4" }
const _hoisted_37 = /*#__PURE__*/_createStaticVNode("<div class=\"d-flex flex-stack flex-grow-1\"><div class=\"fw-bold\"><div class=\"fs-6 text-gray-700\"> By connecting an account, you hereby agree to our <a href=\"#\" class=\"me-1\">privacy policy</a>and <a href=\"#\">terms of use</a>. </div></div></div>", 1)
const _hoisted_38 = /*#__PURE__*/_createStaticVNode("<div class=\"py-2\"><div class=\"d-flex flex-stack\"><div class=\"d-flex\"><img src=\"media/svg/brand-logos/google-icon.svg\" class=\"w-30px me-6\" alt=\"\"><div class=\"d-flex flex-column\"><a href=\"#\" class=\"fs-5 text-dark text-hover-primary fw-bolder\">Google</a><div class=\"fs-6 fw-bold text-muted\"> Plan properly your workflow </div></div></div><div class=\"d-flex justify-content-end\"><label class=\"form-check form-switch form-switch-sm form-check-custom form-check-solid\"><input class=\"form-check-input\" name=\"google\" type=\"checkbox\" value=\"1\" id=\"kt_modal_connected_accounts_google\" checked=\"checked\"><span class=\"form-check-label fw-bold text-muted\" for=\"kt_modal_connected_accounts_google\"></span></label></div></div><div class=\"separator separator-dashed my-5\"></div><div class=\"d-flex flex-stack\"><div class=\"d-flex\"><img src=\"media/svg/brand-logos/github.svg\" class=\"w-30px me-6\" alt=\"\"><div class=\"d-flex flex-column\"><a href=\"#\" class=\"fs-5 text-dark text-hover-primary fw-bolder\">Github</a><div class=\"fs-6 fw-bold text-muted\"> Keep eye on on your Repositories </div></div></div><div class=\"d-flex justify-content-end\"><label class=\"form-check form-switch form-switch-sm form-check-custom form-check-solid\"><input class=\"form-check-input\" name=\"github\" type=\"checkbox\" value=\"1\" id=\"kt_modal_connected_accounts_github\" checked=\"checked\"><span class=\"form-check-label fw-bold text-muted\" for=\"kt_modal_connected_accounts_github\"></span></label></div></div><div class=\"separator separator-dashed my-5\"></div><div class=\"d-flex flex-stack\"><div class=\"d-flex\"><img src=\"media/svg/brand-logos/slack-icon.svg\" class=\"w-30px me-6\" alt=\"\"><div class=\"d-flex flex-column\"><a href=\"#\" class=\"fs-5 text-dark text-hover-primary fw-bolder\">Slack</a><div class=\"fs-6 fw-bold text-muted\"> Integrate Projects Discussions </div></div></div><div class=\"d-flex justify-content-end\"><label class=\"form-check form-switch form-switch-sm form-check-custom form-check-solid\"><input class=\"form-check-input\" name=\"slack\" type=\"checkbox\" value=\"1\" id=\"kt_modal_connected_accounts_slack\"><span class=\"form-check-label fw-bold text-muted\" for=\"kt_modal_connected_accounts_slack\"></span></label></div></div></div>", 1)
const _hoisted_39 = /*#__PURE__*/_createElementVNode("div", { class: "card-footer border-0 d-flex justify-content-center pt-0" }, [
  /*#__PURE__*/_createElementVNode("button", { class: "btn btn-sm btn-light-primary" }, "Save Changes")
], -1)
const _hoisted_40 = { class: "flex-lg-row-fluid ms-lg-15" }
const _hoisted_41 = { class: "nav nav-custom nav-tabs nav-line-tabs nav-line-tabs-2x border-0 fs-4 fw-bold mb-8" }
const _hoisted_42 = /*#__PURE__*/_createStaticVNode("<li class=\"nav-item\"><a class=\"nav-link text-active-primary pb-4 active\" data-bs-toggle=\"tab\" href=\"#kt_customer_view_overview_tab\">Overview</a></li><li class=\"nav-item\"><a class=\"nav-link text-active-primary pb-4\" data-bs-toggle=\"tab\" href=\"#kt_customer_view_overview_events_and_logs_tab\">Events &amp; Logs</a></li><li class=\"nav-item\"><a class=\"nav-link text-active-primary pb-4\" data-kt-countup-tabs=\"true\" data-bs-toggle=\"tab\" href=\"#kt_customer_view_overview_statements\">Statements</a></li>", 3)
const _hoisted_45 = { class: "nav-item ms-auto" }
const _hoisted_46 = {
  href: "#",
  class: "btn btn-primary ps-7",
  "data-kt-menu-trigger": "click",
  "data-kt-menu-attach": "parent",
  "data-kt-menu-placement": "bottom-end"
}
const _hoisted_47 = { class: "svg-icon svg-icon-2 me-0" }
const _hoisted_48 = {
  class: "tab-content",
  id: "myTabContent"
}
const _hoisted_49 = {
  class: "tab-pane fade show active",
  id: "kt_customer_view_overview_tab",
  role: "tabpanel"
}
const _hoisted_50 = {
  class: "tab-pane fade",
  id: "kt_customer_view_overview_events_and_logs_tab",
  role: "tabpanel"
}
const _hoisted_51 = {
  class: "tab-pane fade",
  id: "kt_customer_view_overview_statements",
  role: "tabpanel"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_Dropdown3 = _resolveComponent("Dropdown3")!
  const _component_PaymentRecords = _resolveComponent("PaymentRecords")!
  const _component_PaymentMethods = _resolveComponent("PaymentMethods")!
  const _component_CreditBalance = _resolveComponent("CreditBalance")!
  const _component_Invoices = _resolveComponent("Invoices")!
  const _component_Logs = _resolveComponent("Logs")!
  const _component_Events = _resolveComponent("Events")!
  const _component_Earnings = _resolveComponent("Earnings")!
  const _component_Statement = _resolveComponent("Statement")!
  const _component_NewCardModal = _resolveComponent("NewCardModal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _hoisted_6,
              _hoisted_7,
              _hoisted_8,
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("div", _hoisted_11, [
                    _hoisted_12,
                    _createElementVNode("span", _hoisted_13, [
                      _createVNode(_component_inline_svg, { src: "media/icons/duotune/arrows/arr066.svg" })
                    ])
                  ]),
                  _hoisted_14
                ]),
                _createElementVNode("div", _hoisted_15, [
                  _createElementVNode("div", _hoisted_16, [
                    _hoisted_17,
                    _createElementVNode("span", _hoisted_18, [
                      _createVNode(_component_inline_svg, { src: "media/icons/duotune/arrows/arr065.svg" })
                    ])
                  ]),
                  _hoisted_19
                ]),
                _createElementVNode("div", _hoisted_20, [
                  _createElementVNode("div", _hoisted_21, [
                    _hoisted_22,
                    _createElementVNode("span", _hoisted_23, [
                      _createVNode(_component_inline_svg, { src: "media/icons/duotune/arrows/arr066.svg" })
                    ])
                  ]),
                  _hoisted_24
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_25, [
              _createElementVNode("div", _hoisted_26, [
                _createTextVNode(" Details "),
                _createElementVNode("span", _hoisted_27, [
                  _createElementVNode("span", _hoisted_28, [
                    _createVNode(_component_inline_svg, { src: "media/icons/duotune/arrows/arr072.svg" })
                  ])
                ])
              ]),
              _hoisted_29
            ]),
            _hoisted_30
          ])
        ]),
        _createElementVNode("div", _hoisted_32, [
          _hoisted_33,
          _createElementVNode("div", _hoisted_34, [
            _createElementVNode("div", _hoisted_35, [
              _createElementVNode("span", _hoisted_36, [
                _createVNode(_component_inline_svg, { src: "media/icons/duotune/art/art006.svg" })
              ]),
              _hoisted_37
            ]),
            _hoisted_38
          ]),
          _hoisted_39
        ])
      ]),
      _createElementVNode("div", _hoisted_40, [
        _createElementVNode("ul", _hoisted_41, [
          _hoisted_42,
          _createElementVNode("li", _hoisted_45, [
            _createElementVNode("a", _hoisted_46, [
              _createTextVNode(" Actions "),
              _createElementVNode("span", _hoisted_47, [
                _createVNode(_component_inline_svg, { src: "media/icons/duotune/arrows/arr072.svg" })
              ])
            ]),
            _createVNode(_component_Dropdown3)
          ])
        ]),
        _createElementVNode("div", _hoisted_48, [
          _createElementVNode("div", _hoisted_49, [
            _createVNode(_component_PaymentRecords, { "card-classes": "mb-6 mb-xl-9" }),
            _createVNode(_component_PaymentMethods, { "card-classes": "mb-6 mb-xl-9" }),
            _createVNode(_component_CreditBalance, { "card-classes": "mb-6 mb-xl-9" }),
            _createVNode(_component_Invoices, { "card-classes": "mb-6 mb-xl-9" })
          ]),
          _createElementVNode("div", _hoisted_50, [
            _createVNode(_component_Logs, { "card-classes": "mb-6 mb-xl-9" }),
            _createVNode(_component_Events, { "card-classes": "mb-6 mb-xl-9" })
          ]),
          _createElementVNode("div", _hoisted_51, [
            _createVNode(_component_Earnings, { "card-classes": "mb-6 mb-xl-9" }),
            _createVNode(_component_Statement, { "card-classes": "mb-6 mb-xl-9" })
          ])
        ])
      ])
    ]),
    _createVNode(_component_NewCardModal)
  ], 64))
}